var exports = {
  "l": "viewed__ObsxMH",
  "e": "iconOnly__kjZ2po",
};

module.exports = exports;
